import rawMethodology from './methodology.generated.json'
import type { AssetDefinition, MethodologyData } from '../types'

export const methodology = rawMethodology as MethodologyData

export const assets: AssetDefinition[] = [
  {
    id: 'water-pipe', sector: 'Vodovody', group: 'Potrubí', label: 'Vodovodní potrubí',
    description: 'Tabulka č. 6 – libovolné DN, materiál a způsob uložení.', kind: 'pipe', tableKey: 'waterPipe', table: '6',
  },
  {
    id: 'surface-reservoir-intake', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Odběr z vodárenské nádrže',
    description: 'Odběrný objekt oceněný podle obestavěného prostoru.', kind: 'fixed', fixedId: 'surface-reservoir-intake',
  },
  {
    id: 'surface-stream-intake', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Odběr z volného toku',
    description: 'Odběrný objekt oceněný podle obestavěného prostoru.', kind: 'fixed', fixedId: 'surface-stream-intake',
  },
  {
    id: 'bore-low', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Nízkoprofilový vrt do 40 m',
    description: 'Podzemní zdroj podle hloubky vrtu.', kind: 'fixed', fixedId: 'bore-low',
  },
  {
    id: 'bore-deep', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Nízkoprofilový vrt nad 40 m',
    description: 'Podzemní zdroj podle hloubky vrtu.', kind: 'fixed', fixedId: 'bore-deep',
  },
  {
    id: 'well', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Kopaná nebo vrtaná studna',
    description: 'Studna oceněná podle hloubky.', kind: 'fixed', fixedId: 'well',
  },
  {
    id: 'collector-cut', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Jímací zářez',
    description: 'Jímací zářez oceněný podle délky.', kind: 'fixed', fixedId: 'collector-cut',
  },
  {
    id: 'spring-chamber', sector: 'Vodovody', group: 'Vodní zdroje', label: 'Pramenní nebo sběrná jímka',
    description: 'Složený výpočet zemního vodojemu a navazujícího vodovodního potrubí.', kind: 'composite-spring', table: '2 + 6',
  },
  {
    id: 'water-treatment', sector: 'Vodovody', group: 'Úprava vody', label: 'Úpravna vody',
    description: 'Tabulka č. 1 – jednostupňová nebo dvoustupňová technologie.', kind: 'table-cu', table: '1',
    variants: [
      { value: 'single', label: 'Jednostupňová technologie' },
      { value: 'double', label: 'Dvoustupňová technologie' },
    ],
    parameterLabel: 'Výkon úpravny vody', parameterUnit: 'l/s',
  },
  {
    id: 'ground-reservoir', sector: 'Vodovody', group: 'Vodojemy', label: 'Zemní vodojem',
    description: 'Tabulka č. 2 – cenový ukazatel podle užitného objemu.', kind: 'table-cu', tableKey: 'groundReservoir', table: '2',
    parameterLabel: 'Užitný objem', parameterUnit: 'm³',
  },
  {
    id: 'tower-reservoir', sector: 'Vodovody', group: 'Vodojemy', label: 'Věžový vodojem',
    description: 'Tabulka č. 3 – cenový ukazatel podle užitného objemu.', kind: 'table-cu', tableKey: 'towerReservoir', table: '3',
    parameterLabel: 'Užitný objem', parameterUnit: 'm³',
  },
  {
    id: 'chlorination', sector: 'Vodovody', group: 'Vodojemy', label: 'Samostatné dochlorování',
    description: 'Pevná cena samostatného objektu dochlorování.', kind: 'fixed', fixedId: 'chlorination',
  },
  {
    id: 'water-pump', sector: 'Vodovody', group: 'Čerpací stanice', label: 'Vodárenská čerpací stanice',
    description: 'Tabulky č. 4 a 5 podle dopravní výšky.', kind: 'table-cu', table: '4/5',
    variants: [
      { value: 'low', label: 'Výtlak do H = 60 m' },
      { value: 'high', label: 'Výtlak nad H = 60 m' },
    ],
    parameterLabel: 'Kapacita Qč', parameterUnit: 'l/s',
  },
  {
    id: 'pressure-tunnel-small', sector: 'Vodovody', group: 'Ostatní objekty', label: 'Tlaková štola do 2,40 m',
    description: 'Měrná cena tlakové štoly podle délky.', kind: 'fixed', fixedId: 'pressure-tunnel-small',
  },
  {
    id: 'pressure-tunnel-large', sector: 'Vodovody', group: 'Ostatní objekty', label: 'Tlaková štola nad 2,41 m',
    description: 'Měrná cena tlakové štoly podle délky.', kind: 'fixed', fixedId: 'pressure-tunnel-large',
  },
  {
    id: 'gravity-pipe', sector: 'Kanalizace', group: 'Stoky', label: 'Kruhová gravitační stoka',
    description: 'Tabulka č. 9 – libovolné DN, materiál a způsob uložení.', kind: 'pipe', tableKey: 'gravityPipe', table: '9',
  },
  {
    id: 'pressure-pipe', sector: 'Kanalizace', group: 'Stoky', label: 'Tlaková nebo podtlaková stoka',
    description: 'Tabulka č. 11 – libovolné DN, materiál a způsob uložení.', kind: 'pipe', tableKey: 'pressurePipe', table: '11',
  },
  {
    id: 'noncircular', sector: 'Kanalizace', group: 'Stoky', label: 'Tlamová nebo vejčitá stoka',
    description: 'Tabulka č. 10 – přesné profily nebo pracovní odhad podle prvního rozměru.', kind: 'noncircular', tableKey: 'noncircular', table: '10',
    variants: [
      { value: 'tlamove', label: 'Tlamový profil' },
      { value: 'vejcite', label: 'Vejčitý profil' },
    ],
  },
  {
    id: 'wwtp', sector: 'Kanalizace', group: 'Čistírny odpadních vod', label: 'Mechanicko-biologická ČOV',
    description: 'Tabulky č. 7a a 7b – měrný ukazatel podle počtu EO.', kind: 'wwtp', table: '7a/7b',
    parameterLabel: 'Počet ekvivalentních obyvatel', parameterUnit: 'EO',
  },
  {
    id: 'root-zone-wwtp', sector: 'Kanalizace', group: 'Čistírny odpadních vod', label: 'Kořenová ČOV',
    description: 'Pevný měrný cenový ukazatel na jednoho EO.', kind: 'fixed', fixedId: 'root-zone-wwtp',
  },
  {
    id: 'sewer-pump', sector: 'Kanalizace', group: 'Čerpací stanice', label: 'Kanalizační čerpací stanice',
    description: 'Tabulka č. 8 – cenový ukazatel podle kapacity.', kind: 'table-cu', tableKey: 'sewerPump', table: '8',
    parameterLabel: 'Kapacita Qč', parameterUnit: 'l/s',
  },
  ...['septic-filter', 'holding-tank', 'domestic-wwtp', 'retention-basin', 'domestic-pressure-station', 'vacuum-valve', 'open-drain', 'stone-channel', 'concrete-channel'].map((id) => {
    const fixed = methodology.fixedAssets.find((item) => item.id === id)!
    return {
      id, sector: fixed.sector, group: id === 'retention-basin' ? 'Nádrže a zdrže' : id.includes('channel') || id === 'open-drain' ? 'Otevřená koryta' : 'Ostatní objekty',
      label: fixed.label, description: `Metodický pokyn – ${fixed.source}.`, kind: 'fixed' as const, fixedId: id,
    }
  }),
  {
    id: 'simplified', sector: 'Přepočet', group: 'Zjednodušený přepočet', label: 'Přepočet ceny z období 2020–2025',
    description: 'Tabulka č. 13 – přepočet ceny vypočtené podle staršího metodického pokynu.', kind: 'simplified', tableKey: 'simplified', table: '13',
  },
]

export const assetById = new Map(assets.map((asset) => [asset.id, asset]))

export const defaultInputValues = {
  assetId: 'water-pipe',
  k5Id: 5,
  parameter: 1,
  secondaryParameter: 0,
  length: 1,
  dn: 100,
  material: 'PVC/PE',
  baseMaterial: 'PVC/PE',
  surface: 'n' as const,
  variant: 'single',
  materialCoefficient: 1,
  k1: 1,
  hardening: false,
  ozonation: false,
  collector: false,
  crossingLength: 0,
  crossingRate: 0,
  atypicalCost: 0,
  oldPrice: 1_000_000,
  simplifiedIndex: 0,
}
